/** O botão da barra superior, à esquerda do avatar. Só existe para quem tem a
 *  permissão e com o assistente ligado no runtime; sem isso não há estado
 *  desabilitado, não há botão. Aberto, veste o mesmo tinte que a barra lateral
 *  dá ao item da tela atual. */
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { alpha } from '@mui/material/styles'
import { Sparkles } from 'lucide-react'
import { useI18n } from '@/core/i18n/useI18n'
import { EASE_ORGANIC } from '@/styles/theme'
import { useAssistente } from './AssistenteProvider'

const ehMac = () => /Mac|iPhone|iPad/.test(typeof navigator === 'undefined' ? '' : navigator.platform)

export function AssistenteButton() {
  const { ativo, aberto, alternar, botaoRef } = useAssistente()
  const { t } = useI18n()
  if (!ativo) return null

  const atalho = ehMac() ? '⌘J' : 'Ctrl+J'
  const dica = (
    <Box sx={{ display: 'grid', gap: 0.25 }}>
      <Typography component="span" sx={{ fontSize: '0.8125rem', fontWeight: 600 }}>{t('assistente.botao.dica')}</Typography>
      <Typography component="span" sx={{ fontSize: '0.6875rem', color: 'text.secondary', fontVariantNumeric: 'tabular-nums' }}>
        {atalho}
      </Typography>
    </Box>
  )

  return (
    <Tooltip title={dica} enterDelay={400}>
      <IconButton
        ref={botaoRef}
        onClick={alternar}
        aria-pressed={aberto}
        aria-label={t('assistente.botao')}
        aria-keyshortcuts="Control+J Meta+J"
        sx={{
          flex: 'none',
          width: 40,
          height: 40,
          borderRadius: '0 12px 0 12px',
          color: aberto ? 'primary.main' : 'text.secondary',
          bgcolor: (tema) => (aberto ? alpha(tema.palette.primary.main, tema.palette.mode === 'dark' ? 0.16 : 0.07) : 'transparent'),
          transition: `color 180ms ${EASE_ORGANIC}, background-color 180ms ${EASE_ORGANIC}`,
          '&:hover': {
            color: aberto ? 'primary.main' : 'text.primary',
            bgcolor: (tema) => (aberto ? alpha(tema.palette.primary.main, tema.palette.mode === 'dark' ? 0.22 : 0.11) : 'action.hover'),
          },
        }}
      >
        <Sparkles size={20} strokeWidth={2} />
      </IconButton>
    </Tooltip>
  )
}
